export const InsertWarranty = (value) => {
  return {
    invImage: value.invImage ? value.invImage[0].originFileObj : null,
    packageImage: value.packageImage ? value.packageImage[0].originFileObj : null,
    telephone: value.telephone,
    fullName: value.fullName,
    warrantyNumberCode: value.warrantyNumberCode,
    mobileBrandId: value.mobileBrandId,
    mobileModelId: value.mobileModelId,
    mapProductId: value.mapProductId,
    channelBuyId: value.channelBuyId,
    storeId: value.storeId,
  };
};
